import CryptoJS from 'crypto-js';
import { userLightNote } from '../constants/constants';
import { validateToken } from '../service/token';

const { VITE_SECRET_KEY } = import.meta.env;

const isValidDecryptedToken = async (encryptedToken: string) => {
  const decData = CryptoJS.enc.Base64.parse(encryptedToken).toString(
    CryptoJS.enc.Utf8
  );
  const { VITE_SECRET_KEY } = import.meta.env;

  const decryptedToken = CryptoJS.AES.decrypt(
    decData,
    VITE_SECRET_KEY || 'secret-key'
  ).toString(CryptoJS.enc.Utf8);
  let plainToken: string;
  try {
    plainToken = JSON.parse(decryptedToken);
  } catch {
    plainToken = decryptedToken.replace(/^"+|"+$/g, '');
  }
  const tokenValid = await validateToken(plainToken);
  if (!tokenValid) localStorage.removeItem(userLightNote);
  return tokenValid ? plainToken : null;
};

export const getStoredToken = async (): Promise<string | null> => {
  const storedData = localStorage.getItem(userLightNote);
  if (storedData) {
    try {
      const parsed = JSON.parse(storedData);
      const decryptedToken = await isValidDecryptedToken(parsed.token);

      return decryptedToken || null;
    } catch {
      localStorage.removeItem(userLightNote);
      return null;
    }
  }
  return null;
};

export const setStoredToken = (token: string) => {
  const encJson = CryptoJS.AES.encrypt(
    JSON.stringify(token),
    VITE_SECRET_KEY || 'secret-key'
  ).toString();
  const encryptedToken = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(encJson)
  );
  localStorage.setItem(
    userLightNote,
    JSON.stringify({ token: encryptedToken })
  );
};
